import { type FC } from "react";
import ReactDiffViewer, { DiffMethod } from "react-diff-viewer";

interface ToolDiffSectionProps {
  /** Section heading shown above the diff (e.g. "Schema", "Function body"). */
  title: string;
  oldValue: string;
  newValue: string;
  /** Optional left/right column captions (rendered by react-diff-viewer). */
  leftTitle?: string;
  rightTitle?: string;
  /** When set, wraps the diff in a bordered scrollable container of this pixel height. */
  maxHeight?: number;
  /** Font-size override for the diff body, in pixels. Default 13. */
  fontSize?: number;
}

/** Shared section header + react-diff-viewer block. */
const ToolDiffSection: FC<ToolDiffSectionProps> = ({
  title,
  oldValue,
  newValue,
  leftTitle,
  rightTitle,
  maxHeight,
  fontSize = 13,
}) => {
  const viewer = (
    <ReactDiffViewer
      oldValue={oldValue}
      newValue={newValue}
      splitView
      useDarkTheme={false}
      compareMethod={DiffMethod.LINES}
      leftTitle={leftTitle}
      rightTitle={rightTitle}
      styles={{
        diffContainer: { fontSize: `${fontSize}px` },
        contentText: {
          fontFamily:
            'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono", monospace',
          lineHeight: "1.5",
        },
      }}
    />
  );

  return (
    <div className="space-y-2">
      <div className="text-xs font-medium uppercase tracking-wider text-gray-500">{title}</div>
      {maxHeight !== undefined ? (
        <div
          className="overflow-auto rounded-lg border border-gray-200"
          style={{ maxHeight: `${maxHeight}px` }}
        >
          {viewer}
        </div>
      ) : (
        viewer
      )}
    </div>
  );
};

export default ToolDiffSection;
